import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { removeToken } from "../../ auth"; 
import logo from "../../assets/img/logoN.png";
import api from "../../services/api";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function SidebarRegion() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [regionName, setRegionName] = useState("");

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    // Récupérer le nom de la région
    api.get("/auth/me")
      .then((res) => {
        const userData = res.data?.user || res.data;
        setRegionName(userData?.region?.name || "");
      })
      .catch((err) => console.error("Erreur chargement région:", err));
  }, []);

  const handleLogout = () => {
    removeToken();
    navigate("/");
  };

  return (
    <>
      {/* Barre horizontale pour mobile */}
      <nav className="d-lg-none bg-dark text-white shadow-sm position-fixed top-0 start-0 end-0" style={{ zIndex: 1000 }}>
        <div className="container-fluid">
          <div className="d-flex align-items-center justify-content-between flex-wrap py-2">
            <div
              className="d-flex align-items-center cursor-pointer flex-grow-1"
              onClick={() => navigate("/dashboard-region")}
              style={{ cursor: "pointer", minWidth: 0 }}
            >
              <img src={logo} alt="logo" style={{ height: "40px", marginRight: "10px", flexShrink: 0 }} />
              <div className="d-flex flex-column" style={{ minWidth: 0, overflow: "hidden" }}>
                <span className="fs-6 fw-bold">Région</span>
                {regionName && (
                  <small className="text-light text-truncate">{regionName}</small>
                )}
              </div>
            </div>
            <button
              className="btn btn-outline-light"
              type="button"
              onClick={() => setIsOpen(!isOpen)}
            >
              <i className={`bi ${isOpen ? "bi-x" : "bi-list"}`}></i>
            </button>
          </div>
          {/* Menu déroulant mobile */}
          <div className={`${isOpen ? "d-block" : "d-none"} pb-2`}>
            <div className="d-flex flex-column gap-2">
              <button
                className={`btn text-white text-start w-100 ${
                  isActive("/dashboard-region/aspirants") ? "fw-bold bg-secondary" : ""
                }`}
                onClick={() => {
                  navigate("/dashboard-region/aspirants");
                  setIsOpen(false);
                }}
              >
                <i className="bi bi-people me-2"></i>Gérer les élèves
              </button>
              <button
                className={`btn text-white text-start w-100 ${
                  isActive("/dashboard-region/preuves") ? "fw-bold bg-secondary" : ""
                }`}
                onClick={() => {
                  navigate("/dashboard-region/preuves");
                  setIsOpen(false);
                }}
              >
                <i className="bi bi-file-check me-2"></i>Visualiser les exigences
              </button>
              <button 
                className="btn btn-outline-danger btn-sm" 
                onClick={handleLogout}
              >
                <i className="bi bi-box-arrow-left me-1"></i>Déconnexion
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar vertical pour desktop */}
      <div className="d-none d-lg-flex flex-column bg-dark text-white p-3" style={{ width: "250px", minHeight: "100vh" }}>
        <div
          className="mb-4 text-center cursor-pointer"
          onClick={() => navigate("/dashboard-region")}
          style={{ cursor: "pointer" }}
        >
          <img src={logo} alt="logo" style={{ maxWidth: "120px", marginBottom: "10px" }} />
          <h4 className="mt-2">Région {regionName}</h4>
        </div>
        <ul className="nav nav-pills flex-column">
          <li className="nav-item mb-2">
            <button
              className={`btn text-start text-white w-100 ${isActive("/dashboard-region/aspirants") ? "fw-bold" : ""}`}
              onClick={() => navigate("/dashboard-region/aspirants")}
            >
              <i className="bi bi-people me-2 text-info"></i>Gérer les élèves
            </button>
          </li>
          <li className="nav-item mb-2">
            <button
              className={`btn text-start text-white w-100 ${isActive("/dashboard-region/preuves") ? "fw-bold" : ""}`}
              onClick={() => navigate("/dashboard-region/preuves")}
            >
              <i className="bi bi-file-check me-2 text-info"></i>Visualiser les exigences
            </button>
          </li>
        </ul>

        <div className="mt-auto pt-4">
          <button className="btn btn-outline-danger w-100" onClick={handleLogout}>
            <i className="bi bi-box-arrow-left me-2"></i>Déconnexion
          </button>
        </div>
      </div>
    </>
  );
}

